import { render, staticRenderFns } from "./ArticleTextTabButton.vue?vue&type=template&id=ce38f0e4&"
import script from "./ArticleTextTabButton.vue?vue&type=script&lang=ts&"
export * from "./ArticleTextTabButton.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTextTabButton.vue?vue&type=style&index=0&id=ce38f0e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports